if (!customElements.get('mthr-why-protein')) customElements.define('mthr-why-protein', class extends HTMLElement {
  connectedCallback() {
    this.controller?.abort(); this.controller = new AbortController();
    const options = {signal:this.controller.signal};
    const dialog = this.querySelector('dialog');
    const opener = document.getElementById(this.dataset.opener);
    opener?.addEventListener('click', () => dialog.showModal(), options);
    this.querySelector('[data-close]').addEventListener('click', () => dialog.close(), options);
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r=dialog.getBoundingClientRect(); if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) dialog.close(); } }, options);
  }
  disconnectedCallback() { this.controller?.abort(); }
});
